import React from "react";
import { ContentGrid, SectionBox } from "../styles";
import { Card, Button, Pill } from "../components";
import Icon from "../components/Icon";
import { startKYC } from "../../../../../utils/services/user.service";

const KYCView = ({
  kycVeriffStatus,
  setKycVeriffStatus,
  veriffSessionId,
  setVeriffSessionId,
  verificationUrl,
  setVerificationUrl,
  veriffMode,
  setVeriffMode,
  pushToast,
  uid,
  setAudit,
  setKycStatus,
}) => {
  const startVeriff = async (mode) => {
    setVeriffMode(mode);
    if (mode === "kyc") {
      setKycVeriffStatus("in_progress");
    }

    try {
      const res = await startKYC({});
      const data = res?.data;
      const verification = data?.verification;
      const url = verification?.url;
      const sessionId = verification?.sessionId || verification?.session_id || (url && url.split("/").filter(Boolean).pop()?.split("?")[0]) || "";

      if (url) {
        setVerificationUrl(url);
        setVeriffSessionId(sessionId || veriffSessionId || "—");
        pushToast("KYC", "KYC session started");
        setAudit((s) => [{ id: uid(), ts: new Date().toISOString().slice(0, 16).replace("T", " "), actor: "system", type: "KYC", detail: "KYC session started: " + (sessionId || url), severity: "med" }, ...s]);
        window.open(url, "_blank");
      } else {
        pushToast("KYC", data?.message || data?.Message || "No verification URL returned");
        if (mode === "kyc") setKycVeriffStatus("none");
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.Message || "Failed to start KYC";
      pushToast("KYC", msg);
      if (mode === "kyc") setKycVeriffStatus("none");
    }
  };

  const simulateVeriffCallback = async (mode, decision) => {
    await new Promise((r) => setTimeout(r, 800));
    if (mode === "kyc") {
      setKycVeriffStatus(decision);
      if (decision === "approved") setKycStatus("approved");
    }
    pushToast("KYC", "Decision: " + decision);
    setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:21", actor: "system", type: "KYC", detail: "Veriff decision: " + decision, severity: decision === "approved" ? "low" : "high" }, ...s]);
  };

  return (
    <ContentGrid>
      <Card title="KYC (Person) • Veriff" icon="shield" right={<Pill tone={kycVeriffStatus === "approved" ? "d" : kycVeriffStatus === "in_progress" ? "c" : "b"}>{kycVeriffStatus.replace("_", " ")}</Pill>}>
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>Identity verification powered by Veriff API (startKYC + verificationUrl).</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Button variant="sec" disabled={kycVeriffStatus === "in_progress"} onClick={() => void startVeriff("kyc")} icon="check">
              Start KYC
            </Button>
            <Button disabled={kycVeriffStatus !== "in_progress"} onClick={() => void simulateVeriffCallback("kyc", "approved")}>Mock approve</Button>
            <Button variant="danger" disabled={kycVeriffStatus !== "in_progress"} onClick={() => void simulateVeriffCallback("kyc", "rejected")}>Mock reject</Button>
          </div>
          <SectionBox>
            <div style={{ fontWeight: 900 }}>Last session</div>
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>SessionId: <b style={{ color: "rgba(240,250,255,.92)" }}>{veriffSessionId || "—"}</b></div>
            <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>verificationUrl: <b style={{ color: "rgba(240,250,255,.92)" }}>{verificationUrl || "—"}</b></div>
          </SectionBox>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default KYCView;
